import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PayBoxPayment = () => {
  const [searchParams] = useSearchParams();
  const amount = searchParams.get('amount') || '0';
  const name = searchParams.get('name') || '';
  const orderNum = searchParams.get('order') || '';
  const [error, setError] = useState('');
  const [phone, setPhone] = useState('');
  const [webFallback, setWebFallback] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/payment-providers/config`);
        if (!mounted) return;
        const phoneRaw = (data.paybox_phone || '').replace(/[-\s]/g, '');
        const business = data.business_name || 'בריאות הגבר';
        if (!phoneRaw) {
          setError('פייבוקס אינו מוגדר כרגע');
          return;
        }
        setPhone(phoneRaw);
        const amt = parseFloat(amount).toFixed(2);
        const desc = `${business}${orderNum ? ' - #' + orderNum : ''}`;
        // PayBox universal link - opens in app on mobile, in browser on desktop
        const paybox = `https://link.payboxapp.com/go/pay?phone=${phoneRaw}&amount=${amt}&description=${encodeURIComponent(desc)}`;
        setWebFallback(paybox);
        // Auto-redirect on mobile (universal link -> app if installed)
        window.location.href = paybox;
      } catch (_e) {
        if (mounted) setError('שגיאה בטעינת פייבוקס');
      }
    })();
    return () => { mounted = false; };
  }, [amount, orderNum, name]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4" dir="rtl">
        <div className="text-center">
          <p className="text-red-500 font-bold mb-2">{error}</p>
          <p className="text-stone-400 text-sm">נסו שוב מאוחר יותר</p>
        </div>
      </div>
    );
  }

  const amt = parseFloat(amount).toFixed(2);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4" dir="rtl">
      <div className="text-center max-w-sm w-full" data-testid="paybox-redirect-loading">
        <div className="w-16 h-16 bg-[#6366f1] rounded-2xl mx-auto mb-4 flex items-center justify-center">
          <span className="text-white font-black" style={{ fontFamily: 'Arial, sans-serif' }}>PayBox</span>
        </div>
        <div className="w-8 h-8 border-3 border-[#6366f1] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-stone-600 font-bold mb-1">מעביר לפייבוקס...</p>
        <p className="text-stone-500 text-sm mb-6">סכום: <span className="font-bold">{amt} ש״ח</span></p>

        {webFallback && (
          <a
            href={webFallback}
            className="inline-block bg-[#6366f1] hover:bg-[#4f46e5] text-white font-bold px-6 py-3 rounded-xl transition-colors"
            data-testid="paybox-manual-link"
          >
            פתח את פייבוקס
          </a>
        )}

        {phone && (
          <p className="text-stone-400 text-xs mt-6">
            אם לא נפתח אוטומטית, העבירו לטלפון:<br />
            <span dir="ltr" className="font-mono font-bold text-stone-600">{phone}</span>
          </p>
        )}

        <p className="text-center text-[11px] text-stone-500 mt-6 px-2 leading-relaxed" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="terms-disclaimer-paybox">
          בלחיצה על המשך תשלום, קראתי והנני מאשר את{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#D97706] hover:underline font-bold">
            תנאי השימוש ותקנון האתר
          </a>
        </p>
      </div>
    </div>
  );
};

export default PayBoxPayment;
